import React from "react";
import styled, { keyframes } from "styled-components";

const Loading = () => {
  return <LoadingSpinner />;
};

export default Loading;

// 스핀 애니메이션 정의
const spin = keyframes`
  to {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
`;

// 로딩 스타일 컴포넌트
const LoadingSpinner = styled.div`
  content: "";
  display: block;
  height: 50px;
  width: 50px;
  -webkit-animation: ${spin} 0.5s infinite linear;
  animation: ${spin} 0.5s infinite linear;
  border: 6px solid #fff;
  border-left-color: #bcbcbc;
  border-radius: 50%;

  position: absolute;
  top: calc(50% - 25px);
  left: calc(50% - 25px);
`;
